export const AI_ANSWER_PADDING = 20;

export const AI_ANSWER_GAP = 12;

export const AI_ICON_HEGHT = 24;

export const LOADING_ANIMATION_PADDING = 60;

export const LOADING_ANIMATION_WIDTH = 150;

export const LOADING_ANIMATION_HEIGHT = 120;

export const PATH_TO_STATIC = "/api/v2/static/media/ai-agent/";

export const AI_TITLES = {
    retro_summary: "Итоги ретро",
    short_summary: "Краткое содержание",
};
